"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingUtils = exports.TrackingType = void 0;
var TrackingType;
(function (TrackingType) {
    TrackingType[TrackingType["pageView"] = 1] = "pageView";
    TrackingType[TrackingType["trackEvent"] = 2] = "trackEvent";
})(TrackingType = exports.TrackingType || (exports.TrackingType = {}));
class TrackingUtils {
    static pageContext(dealerId) {
        if (dealerId && dealerId !== '') {
            return 'Dealer';
        }
        else {
            return 'Importer';
        }
    }
}
exports.TrackingUtils = TrackingUtils;
